import { buffers, SagaIterator } from 'redux-saga';
import { makeRestRequest } from 'src/modules/api/sagas/utils/makeRestRequest';
import { basedataSaga } from 'src/modules/basedata/sagas/basedataSaga';
import { CONFIG_FETCH } from 'src/modules/config/actions/ConfigActions';
import { configSaga } from 'src/modules/config/sagas/configSaga';
import { feedbackSaga } from 'src/modules/feedback/sagas/feedbackSaga';
import { hvacSaga } from 'src/modules/hvac/sagas/hvacSaga';
import { loaderSaga } from 'src/modules/loader/sagas/loaderSaga';
import { loginSaga } from 'src/modules/login/sagas/loginSaga';
import { modalStackSaga } from 'src/modules/modals/sagas/modalStackSaga';
import { projectEventSaga } from 'src/modules/project-event/sagas/projectEventSaga';
import { projectListSaga } from 'src/modules/project-list/sagas/projectListSaga';
import { projectNewSaga } from 'src/modules/project-new/sagas/projectNewSaga';
import { projectSyncSaga } from 'src/modules/project-sync/sagas/projectSyncSaga';
import { projectViewSaga } from 'src/modules/project-view/sagas/projectViewSaga';
import { isLocationChangeAction } from 'src/modules/routing/actions/LocationChange';
import { routingSaga } from 'src/modules/routing/sagas/routingSaga';
import { saveProjectRoot, saveProjectSaga } from 'src/modules/save-project/SaveProjectSaga';
import { actionChannel, call, fork, put, take, takeLatest } from 'typed-redux-saga';

export function* rootSaga(): SagaIterator {
  // collect History navigation until we're ready
  const router = yield* actionChannel(isLocationChangeAction, buffers.sliding(1));

  yield* fork(loaderSaga);
  yield* fork(configSaga);
  // prefetch configuration before starting the app
  yield* put(CONFIG_FETCH.request());
  yield* take(CONFIG_FETCH.isSuccess);
  yield* call(makeRestRequest, 'GET', '/auth/guest');

  yield* fork(routingSaga);
  yield* fork(loginSaga);
  yield* fork(hvacSaga);
  yield* fork(saveProjectRoot);
  yield* fork(basedataSaga);
  yield* fork(projectNewSaga);
  yield* fork(projectSyncSaga);
  yield* fork(projectListSaga);
  yield* fork(projectViewSaga);
  yield* fork(projectEventSaga);
  yield* fork(modalStackSaga);
  yield* fork(feedbackSaga);

  // delayed own routing initialization
  const navigate = yield* take(router);
  yield* put(navigate);
  yield* call(router.close);
}
